export const DRIVE_FETCH_CURRENT_DIRECTORY_SUCCESS = 'DRIVE_FETCH_CURRENT_DIRECTORY_SUCCESS';
export const DRIVE_FETCH_CURRENT_DIRECTORY_REQUEST = 'DRIVE_FETCH_CURRENT_DIRECTORY_REQUEST';
export const DRIVE_FETCH_CURRENT_DIRECTORY_FAILURE = 'DRIVE_FETCH_CURRENT_DIRECTORY_FAILURE';
export const DRIVE_SET_CURRENT_DIRECTORY = 'DRIVE_SET_CURRENT_DIRECTORY';
export const DRIVE_INITIALIZE = 'DRIVE_INITIALIZE';
export const DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_REQUEST = 'DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_REQUEST';
export const DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_FAILURE = 'DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_FAILURE';
export const DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_SUCCESS = 'DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_SUCCESS';
export const DRIVE_ADD_TO_CURRENT_DIRECTORY = 'DRIVE_ADD_TO_CURRENT_DIRECTORY';
export const DRIVE_SET_CURRENT_DOCUMENT = 'DRIVE_SET_CURRENT_DOCUMENT';
export const DRIVE_EDIT_DOCUMENT_ATRIBUTES_REQUEST = 'DRIVE_EDIT_DOCUMENT_ATRIBUTES_REQUEST';
export const DRIVE_REPLACE_DOCUMENT = 'DRIVE_REPLACE_DOCUMENT';
export const DRIVE_REMOVE_DOCUMENTS_REQUEST = 'DRIVE_REMOVE_DOCUMENTS_REQUEST';
export const DRIVE_REMOVE_DOCUMENTS_SUCCESS = 'DRIVE_REMOVE_DOCUMENTS_SUCCESS';
export const DRIVE_REMOVE_DOCUMENTS_FAILURE = 'DRIVE_REMOVE_DOCUMENTS_FAILURE';
export const DRIVE_SELECT_DOCUMENTS = 'DRIVE_SELECT_DOCUMENTS';
export const DRIVE_EDIT_DOCUMENT_ATRIBUTES_SUCCESS = 'DRIVE_EDIT_DOCUMENT_ATRIBUTES_SUCCESS';
export const DRIVE_EDIT_DOCUMENT_ATRIBUTES_FAILURE = 'DRIVE_EDIT_DOCUMENT_ATRIBUTES_FAILURE';
export const DRIVE_REMOVE_DOCUMENT_FROM_STORE_BY_ID = 'DRIVE_REMOVE_DOCUMENT_FROM_STORE_BY_ID';
export const DRIVE_SET_USED_PERCENTAGE = 'DRIVE_SET_USED_PERCENTAGE';
export const DRIVE_SET_ENTIDADES_REQUEST = 'DRIVE_SET_ENTIDADES_REQUEST';
export const DRIVE_SET_ENTIDADES_SUCCESS = 'DRIVE_SET_ENTIDADES_SUCCESS';
export const DRIVE_SET_ENTIDADES_FAILURE = 'DRIVE_SET_ENTIDADES_FAILURE';
export const DRIVE_SET_ENTIDADES = 'DRIVE_SET_ENTIDADES';
export const DRIVE_SET_GB_CONTRATADOS = 'DRIVE_SET_GB_CONTRATADOS';
